import {Injectable} from '@angular/core';
import {Mutation} from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})

export class CambiarClaveGQL extends Mutation {
  document = gql`
            mutation  cambiarClaveUsuario(
                $email: String!
                $clave: String!
                $claveN: String!
              ) {
                cambiarClaveUsuario(
                email: $email
                clave: $clave
                claveN: $claveN
              ) {
                usuario{
                  email
                }
                status
                message
              }
            }`;
}
